import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=982e22ea&scoped=true&"
import script from "./verifyCode.vue?vue&type=script&lang=js&"
export * from "./verifyCode.vue?vue&type=script&lang=js&"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=982e22ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982e22ea",
  null
  
)

export default component.exports